<template>
    <rkm-table
        :fields="fields"
        :items="data.model.procedimentosClinicos"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(codigo)="{item}">
            {{formatProcedimento(item.procedimento.codigo)}}
        </template>

        <template v-slot:cell(cid)="{item}">
            {{item.cid ? `${formatCid(item.cid.codigo)} - ${item.cid.nome}` : '-'}}
        </template>

        <template
            v-if="!readonly"
            v-slot:cell(actions)="{index, item}"
        >
            <rkm-button
                @click="$emit('edit', item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

export default {
    computed: {
        fields() {
            const fields = [
                {key: 'codigo', label: 'Código', sortable: true},
                {key: 'procedimento.nome', label: 'Nome', sortable: true},
                {key: 'cid', label: 'CID', sortable: true},
                {class: 'col-min', key: 'quantidade', label: 'Quantidade', sortable: true},
            ]

            if (!this.readonly) {
                fields.push({class: 'col-min text-center', key: 'actions', label: 'Ações'})
            }

            return fields
        },
    },
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento clínico?', async () => {
                this.data.model.procedimentosClinicos.splice(index, 1)
            })
        },
    },
    mixins: [formats],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>
